import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, concatMap, map, of, throwError, withLatestFrom } from 'rxjs';
import { AddBillingitemsWizardDataV26Service } from 'src/app/services-v26/wizards/add-billingitems-wizard-v26.service';
import { AddBillingitemTopackageWizardActionsV26 } from '.';
import { selectInitStep } from './selectors';
import { State } from './state';

@Injectable()
export class AddBillingitemTopackageWizardEffects {
  newAddBillingitemTopackage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddBillingitemTopackageWizardActionsV26.createNewAddBillingitemTopackage),
      withLatestFrom(this.store.select(selectInitStep)),
      concatMap(([{ request }, initStep]) =>
        this.addBillingitemsWizardService.addBillingitemToPackages(initStep.billingitemId, request).pipe(
          map((response) => {
            if (response) {
              return AddBillingitemTopackageWizardActionsV26.createNewAddBillingitemTopackageSuccess({
                response: response.data,
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(AddBillingitemTopackageWizardActionsV26.createNewAddBillingitemTopackageFail({ errorMessage }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private addBillingitemsWizardService: AddBillingitemsWizardDataV26Service,
  ) {}
}
